/**
 * A URL that carries a credential so a phone doesn't have to be typed at: an invite code
 * (item 16, DECISIONS.md D192). Separate module so `InvitesCard.tsx` exports a component
 * only (D48).
 *
 * A token's own version of this (`tokenUrl`, generating a `#t=` link for `TokenQr.tsx` to
 * render) was removed alongside manual token minting (D201) — nothing mints a plaintext
 * token for the browser to hand off anymore, pairing does not either (the token goes
 * straight to the device that asked for it), so there was nothing left calling it.
 * `api.ts::adoptTokenFromUrl` still reads a `#t=` fragment if one ever shows up by some
 * other means; only the generator side is gone.
 */

/**
 * The URL a friend opens to register with an invite code (`AuthGate.tsx` reads `?invite=`
 * on load to pre-fill the code and switch straight to the register tab).
 *
 * Rides in the **query string**, not the fragment `tokenUrl` uses — deliberately: a query
 * string does reach the server (SWAG's access log, say, if this is ever forwarded over
 * plain http), but an invite code is a much lower-stakes secret than a bearer token. It's
 * single-use, dead the instant it's registered with, revocable, and — per DECISIONS.md
 * D192 — not even bound to a specific username, so a stray copy in a log is a code that still
 * needs to beat a 14-day expiry and get used before the owner notices and revokes it, not a
 * standing credential like a token is.
 */
export function inviteUrl(code: string, origin: string = window.location.origin): string {
  return `${origin}/?invite=${encodeURIComponent(code)}`;
}
